module.exports = "/_next/static/videos/website-fee6c2d5796c19bb21aa838b1f63a99d.mp4";